import styled from 'styled-components'

export const RatePlansWrapper = styled.div`
  width: 100%;
`
